import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import {MagazineCategoryService} from "../../serverService/magazineService/MagazineCategoryService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {MagazineCategoryParser} from "./MagazineCategoryParser";
import MagazineCategoryDetail from "./MagazineCategoryDetail";
import {
    DialogSize,
    RaikoAlert,
    raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoButtonPrimary, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoDefaultDialogPage, RaikoErrorSection, RaikoFlexAlignEnd,
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoSimpleInputOutlined, RaikoTree,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {RaikoErrorSectionVectors} from "../../util/RaikoErrorSectionVectors";

export default function MagazineCategory() {

    const service = new MagazineCategoryService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        getCategoryTree()
    }, []);

    const [name, setName] = useState("");
    const [slug, setSlug] = useState("");
    const [parent, setParent] = useState(-1);
    const [categoryInlineItems, setCategoryInlineItems] = useState([]);
    const [categoryPersianList, setCategoryPersianList] = useState([]);


    function handleChangeCategoryInfo() {
        loading.show()
        service.createNewCategory(name, slug, parent)
            .then(response => {
                showSuccessMessage("دسته بندی جدید با موفقیت افزوده شد.")
                getCategoryTree()
                clearFields()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function getCategoryTree() {
        loading.show()
        service.getCategoryTree()
            .then(response => {

                const categoryParser = new MagazineCategoryParser(response)
                setCategoryPersianList(categoryParser.getCategoryListParsed())
                setCategoryInlineItems(categoryParser.getCategoryListInlineParser())

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function clearFields() {
        setName("")
        setSlug("")
        setParent(-1)
    }

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(-1);

    function handleItemClicked(id) {
        setSelectedCategory(id)
        setOpenDialog(true)
    }

    function handleCloseDialog() {
        setOpenDialog(false)
        setSelectedCategory(-1)
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.MagazineCategory.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                dialogSize={DialogSize.LARGE}
                pageTitle={"جزئیات دسته بندی"}>
                <MagazineCategoryDetail
                    id={selectedCategory}
                    categoryInlineItems={categoryInlineItems}
                    handleUpdateCategoryTree={getCategoryTree}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator("مجله", ""),
                        raikoBreadCrumbItemGenerator(RouteHelper.MagazineCategory.name, RouteHelper.MagazineCategory.url),
                    ]}/>
                    <RaikoGridOneColumn>
                        <RaikoBaseCardContainer>
                            <RaikoGridOneColumn>
                                <RaikoAlert
                                    type={raikoAlertTypes.info}
                                    title={"مشاهده و ویرایش دسته بندی"}
                                    description={[
                                        "* برای افزودن دسته بندی جدید بعد از وارد کردن اطلاعات لازم بر روی دکمه ی افزودن کلیک نمایید.",
                                        "* برای ویرایش دسته بندی های کافی است دسته بندی مورد نظر را انتخاب کرده و بعد از اصلاح جزئیات بر روی بروزرسانی کلیک نمایید."
                                    ]}
                                />
                                <RaikoGridThreeColumn>
                                    <RaikoSimpleInputOutlined
                                        labelText={"نام"} setValue={setName}
                                                              value={name}/>
                                    <RaikoSimpleInputOutlined
                                        labelText={"Slug"} setValue={setSlug}
                                                              value={slug}/>
                                    <RaikoCustomSelect
                                        items={[
                                            raikoCustomSelectItemGenerator(-1, "(دسته بندی اصلی)"),
                                            ...categoryInlineItems
                                        ]}
                                        labelText={"پدر"}
                                        value={parent}
                                        setValue={setParent}
                                    />
                                </RaikoGridThreeColumn>
                                <RaikoFlexAlignEnd>
                                    <RaikoButtonPrimary label={"افزودن"} onClick={handleChangeCategoryInfo}/>
                                </RaikoFlexAlignEnd>

                            </RaikoGridOneColumn>

                        </RaikoBaseCardContainer>
                        <RaikoBaseCardContainer>
                            {categoryPersianList && categoryPersianList.length > 0 ?
                                <RaikoTree
                                    selectedItemsId={[]}
                                    treeItems={categoryPersianList}
                                    handleItemClicked={handleItemClicked}
                                /> :
                                <RaikoErrorSection
                                    title={"هیچ دسته بندی یافت نشد!"}
                                    subTitle={"از بخش بالا می توانید دسته بندی مورد نظر خود را ایجاد نمایید."}
                                    image={RaikoErrorSectionVectors.SORRY_ONE}
                                />}
                        </RaikoBaseCardContainer>
                    </RaikoGridOneColumn>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}